module.exports = __webpack_public_path__ + "static/media/8-g1.66e766a0.jpg";